<template>
  <v-skeleton-loader width="100%" max-width="555" v-if="this.giveawaysLoading" type="card">
  </v-skeleton-loader>
  <div class="pt-5" v-else>
    <div class="mb-2" v-for="gives in giveaways" :key="gives.giveaway_id">
      <GiveawayCard :gives="gives"/>
    </div>
    <Pagination
        class="mt-9 mb-9"
        :page="filters.page"
        :pageCount="+this.giveawaysPageCount"
        v-on:pageChange="onPageChange"/>
  </div>



</template>
<script>
import {mapGetters, mapActions} from "vuex";
import Filter from "@/mixins/Filter";
import Pagination from "@/components/Pagination.vue";
import GiveawayCard from '@/components/Event/GiveawaysCard.vue';
export default {
  components:{
    Pagination,
    GiveawayCard
  },
  methods:{
    ...mapActions('app',['setPageTitle']),
    ...mapActions('event',['getGiveaways'])
  },
  mixins:[Filter],
  computed: {
     ...mapGetters('event',['giveaways','giveawaysLoading','giveawaysError','giveawaysPageCount'])

  },
  mounted() {
    this.setPageTitle('Giveaways')
  },
  created() {
    if(this.$route.query.id !== undefined){
      this.getGiveaways(this.requestQuery);
    }
  }
}

</script>

<style lang="scss">

</style>